import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import "firebase/database";
import "firebase/storage";
import moment from "moment-timezone";
import { v4 as uuidv4 } from "uuid";

const firebaseConfig = {
  apiKey: "AIzaSyA4u-8taMA0gGD3XJ6Ziwuo549p6wjS-3k",
  authDomain: "artext-92d42.firebaseapp.com",
  databaseURL: "https://artext-92d42.firebaseio.com",
  projectId: "artext-92d42",
  storageBucket: "artext-92d42.appspot.com",
  messagingSenderId: "933188415262",
  appId: "1:933188415262:web:6d01b29d553e6a18fbe30f",
};

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    firebase.functions().useEmulator("localhost", 5001);
    //console.log('DEV');
  } else {
    //console.log('PROD');
  }
}
let uploadImageAsync = async (projectnumber, uri) => {
  // Why are we using XMLHttpRequest? See:
  // https://github.com/expo/expo/issues/2402#issuecomment-443726662
  const blob = await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = function () {
      resolve(xhr.response);
    };
    xhr.onerror = function (e) {
      console.log(e);
      reject(new TypeError("Network request failed"));
    };
    xhr.responseType = "blob";
    xhr.open("GET", uri, true);
    xhr.send(null);
  });
  var ref = firebase
    .storage()
    .ref()
    .child(projectnumber)
    .child("Photos correctifs")
    .child(moment().format("YYYY-MM-DD"))
    .child(uuidv4());
  const snapshot = await ref.put(blob);

  // We're done with the blob, close and release it

  return await snapshot.ref.getDownloadURL();
};

export const database = firebase.database();
export const auth = firebase.auth();
export const functions = firebase.app().functions("us-east1");
export { uploadImageAsync };
